export default "__VITE_ASSET__C0TwP_yX__"